import { render } from "./UserReportPage.vue?vue&type=template&id=f01480f6&scoped=true&ts=true"
import script from "./UserReportPage.vue?vue&type=script&lang=ts"
export * from "./UserReportPage.vue?vue&type=script&lang=ts"

import "./UserReportPage.vue?vue&type=style&index=0&id=f01480f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01480f6"]])

export default __exports__